import React from "react";
import styled from "styled-components";
import { FlexBox } from "./FlexBox";

interface ProcessingOverlayProps {
  message: string;
  progress: number;
  throughput: number;
  showStats?: boolean;
}

const Container = styled(FlexBox)`
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
  background: rgba(26, 38, 52, 0.95);
  padding: 32px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

const ProcessingIcon = styled.div`
  width: 48px;
  height: 48px;
  border: 3px solid ${({ theme }) => theme.colors.secondary};
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

const ProgressBar = styled.div<{ progress: number }>`
  width: 100%;
  height: 4px;
  background: #2a3644;
  border-radius: 2px;
  overflow: hidden;

  &::after {
    content: "";
    display: block;
    height: 100%;
    width: ${(props) => props.progress * 100}%;
    background: ${({ theme }) => theme.colors.secondary};
    transition: width 0.3s ease;
  }
`;

const StatsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-top: 16px;
  width: 100%;
  max-width: 400px;
`;

const StatBox = styled.div`
  background: rgba(42, 54, 68, 0.5);
  border-radius: 6px;
  padding: 12px;
  text-align: center;

  .label {
    font-size: 0.875rem;
    color: #8c9cad;
    margin-bottom: 4px;
  }

  .value {
    font-size: 1.25rem;
    font-weight: 600;
    color: #ffffff;
  }
`;

export const ProcessingOverlay: React.FC<ProcessingOverlayProps> = ({
  message,
  progress,
  throughput,
  showStats = false,
}) => {
  return (
    <Container>
      <ProcessingIcon />
      <h3 style={{ margin: 0 }}>{message}</h3>
      <ProgressBar progress={progress} />

      {showStats && (
        <StatsContainer>
          <StatBox>
            <div className="label">Progress</div>
            <div className="value">{(progress * 100).toFixed(1)}%</div>
          </StatBox>
          <StatBox>
            <div className="label">Speed</div>
            <div className="value">{throughput.toFixed(1)} MB/s</div>
          </StatBox>
        </StatsContainer>
      )}
    </Container>
  );
};
